import React from 'react'
import MainIcon from '../../../../../img/svg/main'
import PlatformIcon from '../../../../../img/svg/platforms'
import { statusOptionsStatic } from '../../../../../redux/reducer/order/constants'
import { TextBig } from '../../OrdersTable/index.styled'
import { getNeededDateFormat } from '../../../../../helper'
import { useTranslation } from 'react-i18next'
import { CancellationLabel, MarkReadyWaitingWrapper, PreOrderWrapper, StatusTextWrapper } from './index.styled'
import { getOrderCancellationDate } from './helper'
import { TableTdGrid } from '../../style/table/td/index.styled'
import { useSelector } from 'react-redux'
import { selectCompanyData } from '../../../../../redux/selector/system'
import { useTheme } from 'styled-components'
import MarkReadyOrderButton from './MarkReadyOrderButton'
import RoomChargeFolioMarker from '../../../../RoomCharge/RoomChargeFolioMarker'

const MARK_READY_STATUSES = ['BEING_PREPARED', 'READY']

const OrderStatus = React.memo(({ item }) => {
	const { t } = useTranslation()
	const isDeliveryByPlatform = item.orderType === 'DELIVERY_BY_PLATFORM'
	const isPlatformDriverOrder = isDeliveryByPlatform ||
		(item?.orderType === 'DELIVERY' && !!item?.deliveryMetaData?.partner?.type)
	const showMarkReadyWaiting = item?.platformMetaData?.markedReady === true &&
		MARK_READY_STATUSES.includes(item?.status?.status)
	const showMarkReadyButton = item?.platformMetaData?.platformType === 'WOLT_PLUGIN' &&
		isPlatformDriverOrder &&
		MARK_READY_STATUSES.includes(item?.status?.status)
	const cancellationDate = getOrderCancellationDate(item)
	const countryCode = useSelector(selectCompanyData('countryCode'))
	const { colorTheme } = useTheme()
	const lieferandoIcon = countryCode === 'CHE' ? 'lieferando-che' : 'lieferando-de'
	const platformIcon = item?.platformMetaData?.platformType &&
		(item?.platformMetaData?.platformType === 'TAKEAWAY_PLUGIN' ? lieferandoIcon : item?.platformMetaData?.platformType)

	return (
		<>
			<TableTdGrid>
				<MainIcon icon={item?.status?.status} />
				<StatusTextWrapper>
					<TextBig>{t(statusOptionsStatic.filter(status => status.value === item.status?.status).map(filtered => filtered.label))}</TextBig>
					<RoomChargeFolioMarker salesTransferState={item?.salesTransferState} />
				</StatusTextWrapper>
			</TableTdGrid>
			{cancellationDate && <CancellationLabel><div>{t('order.table.cancellation_mark', { date: getNeededDateFormat(cancellationDate) })}</div></CancellationLabel>}
			{item.preOrder && !['COMPLETED', 'CANCELED', 'ABORTED'].includes(item.status.status) && !isDeliveryByPlatform &&
				<PreOrderWrapper>
					<MainIcon icon="preorder" />
					<div>{getNeededDateFormat(item.preOrder, 'dd.MM.yyyy')}</div>
					<div>{getNeededDateFormat(item.preOrder, 'HH:mm')}</div>
				</PreOrderWrapper>}
			{showMarkReadyWaiting &&
				<MarkReadyWaitingWrapper>
					<PlatformIcon icon={`${platformIcon}-${colorTheme}`} />
					<div>{t('order.table.mark_ready_waiting')}</div>
				</MarkReadyWaitingWrapper>}
			{showMarkReadyButton &&
				<MarkReadyOrderButton item={item} />}
		</>
	)
})

OrderStatus.displayName = 'OrderStatus'
export default OrderStatus
